<template>
<van-field 
  readonly 
  clickable
  name="selectPicker"
  :label="schema.label" 
  :placeholder="schema.placeholder" 
  :value="schema.value"
  :required="schema.required === true" 
/>
</template>

<script>
// import { Notify } from 'vant';

export default {
  name: 'selectPicker',
  props: {
    schema: {
      'type':Object,
      default:{},
      required:true
    },
    pluginIndex:{
      type:Number,
      default:0
    }
  },
  methods:{
    // onScan(){
    //   Notify({ type: 'warning', message: '点击了扫码',duration: 800 });
    // }
  }
}
</script>

<style>

</style>